import {ReactElement} from 'react';
import {Box, Button, Dialog} from '@mui/material';
import {useTranslation} from 'react-i18next';
import TraySummary from 'components/shared/tray/TraySummary';
import {Tray} from 'interfaces/Project';

type Props = {
  tray: Tray;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ShowTray({tray, onCancel, onConfirm}: Props): ReactElement {
  const {t} = useTranslation('common');

  return (
    <Dialog
      open
      onClose={onCancel}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          maxWidth: 714,
          borderRadius: '12px',
          backgroundColor: 'sectionBackground',
          border: '1px solid',
          borderColor: 'borderColor',
          p: 3,
          gap: 3
        }
      }}
    >
      <TraySummary tray={tray} name={tray.name} totalSection={tray.totalSection} t={t} />
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1.5}}>
        <Button size="small" color="inherit" sx={{color: 'ctaDark'}} onClick={onCancel}>
          {t('common:cancel')}
        </Button>
        <Button size="small" variant="outlined" color="primary" onClick={onConfirm}>
          {t('common:select')}
        </Button>
      </Box>
    </Dialog>
  );
}
